import { useRouterState } from '@tanstack/react-router'
import { useSecondaryMenu } from 'ui/components/BPLayout'

const CTRSideBar = () => {
  const pathname = useRouterState({ select: (s) => s.location.pathname })

  useSecondaryMenu([
    { label: 'General Information', hash: 'general' },
    { label: 'Step 1', hash: 'step1' },
    { label: 'Step 2', hash: 'step2' },
    { label: 'Step 3', hash: 'step3' },
    { label: 'Step 4', hash: 'step4' },
    ...(!pathname.endsWith('/edit') ? [{ label: 'History', hash: 'history' }] : [])
  ])

  return null
}

export default CTRSideBar
